export default __webpack_public_path__ + "static/media/pinjamwinwin.22939492.png";